import "./index.scss";

import { MenuItem, Stack } from "@mui/material";
// import MemberListDropdown from "containers/StaffAccounts/Dropdown";
import MemberListDropdown from "components/Dropdown/MemberListDropdown";
import LabelWithValue from "components/LabelWithValue";
import ScreenLoader from "components/ScreenLoader";
import TitleWithOptions from "components/TitleWithOptions";
import { STAFF_STATUS_OPTIONS, STAFF_TYPES } from "constants/index";
import dayjs from "dayjs";
import { bufferFitlinxxId } from "helpers/utils";
import { updateStaffStatus } from "modules/staffs/staffServices";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

const PersonalDetails = ({ data }) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCurrentStatus(data?.status_string || "");
  }, [data]);

  const statusOptions = useMemo(() => {
    return STAFF_STATUS_OPTIONS.filter((item) => item.value !== "");
  }, [STAFF_STATUS_OPTIONS]);

  const onUpdateStatus = async (id, value) => {
    try {
      let result = await updateStaffStatus(data?.id, { status: value });
      if (result.success) {
        toast("Staff status updated successfully", { type: "success" });
        return true;
      } else {
        toast("Staff status update failed", { type: "error" });
        return false;
      }
    } catch (e) {
      toast("Staff status update failed", { type: "error" });
      return false;
    }
  };

  return (
    <Stack direction={"row"} className="staff-personal-info">
      <Stack className="left-container">
        <TitleWithOptions title="Personal Info" />
        <Stack direction="row" gap="40px" mt="16px">
          <Stack flex={1} gap="10px">
            <LabelWithValue label="First name" value={data?.first_name} />
            <LabelWithValue label="Last name" value={data?.last_name} />
            <LabelWithValue
              label="Date of birth"
              value={data?.birth_date ? dayjs(data?.birth_date).format("YYYY/MM/DD") : ""}
              enableViewMode
            />
            <LabelWithValue
              label="Gender"
              value={data?.gender === "M" ? "Male" : "Female"}
              enableViewMode
            />
            <LabelWithValue label="Weight" value={data?.weight || ""} enableViewMode />
            <LabelWithValue label="FitLinxx ID" value={bufferFitlinxxId(data?.fitlinxx_id)} />
            <LabelWithValue
              label="Staff Type"
              value={STAFF_TYPES.find((o) => o.value === data?.type_string)?.label || ""}
            />
            <LabelWithValue
              label="Staff Status"
              value={STAFF_STATUS_OPTIONS.find((o) => o.value === data?.status_string)?.label || ""}
            />
            <LabelWithValue label="Title" value={data?.title || ""} />
            <LabelWithValue label="Email address" value={data?.email || "N/A"} />
            <LabelWithValue label="Primary Phone " value={data?.phone || "N/A"} />
            <LabelWithValue label="Other phone" value={data?.other_phone || "N/A"} />
            {/* <LabelWithValue label="Online Username" value="-" /> */}
            {/* <Button
              label={"Send Online Registration"}
              color={"primary-blue"}
              className="online-registration-button"
            /> */}
          </Stack>

          <Stack flex={1} gap="10px">
            <LabelWithValue label="Address Line 1" value={data?.address || ""} enableViewMode />
            <LabelWithValue label="Address Line 2" value={data?.address_2 || ""} enableViewMode />
            <LabelWithValue label="City" value={data?.city || `N/A`} />
            <LabelWithValue label="State" value={data?.state || `N/A`} />
            <LabelWithValue label="Zip Code" value={data?.postal_code || `N/A`} />
            <LabelWithValue label="Country" value={data?.country || `N/A`} />
          </Stack>
        </Stack>
      </Stack>
      <Stack className="right-container">
        <TitleWithOptions title="Status" />
        {loading && <ScreenLoader isScreenLoader />}
        {!loading && (
          <MemberListDropdown
            name="status"
            label="Status"
            className="select primary"
            value={currentStatus}
            defaultValue={currentStatus}
            onChange={async (e) => {
              setLoading(true);
              let result = await onUpdateStatus(data.id, e.target.value);
              setLoading(false);
              if (result) {
                setCurrentStatus(e.target.value.toString());
              }
            }}
            showLabel={false}
          >
            {statusOptions.map((o) => (
              <MenuItem
                disabled={data?.assigned_members && o.value === "IN_ACTIVE"}
                value={o.value}
              >
                {o.label}
              </MenuItem>
            ))}
          </MemberListDropdown>
        )}
      </Stack>
    </Stack>
  );
};

export default PersonalDetails;
